<template>
  <sf-calculator-tabs v-if="limit !== 'first'">
    <template slot="first">
      <span>{{ $t('calculator.first') }}</span>
      <span class="mob_hide">&nbsp;{{ $t('calculator.loan') }}</span>
    </template>
    <template slot="repeated">
      <span>{{ $t('calculator.repeated') }}</span>
      <span class="mob_hide">&nbsp;{{ $t('calculator.loan') }}</span>
    </template>
  </sf-calculator-tabs>
</template>

<script>
export default {
  name: 'CalculatorTabs',
  props: {
    limit: {
      type: String,
      default: '',
    },
  },
};
</script>
